import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Telefonnummer',
      placeholder: 'Indtast telefonnummer',
    },
    email: {
      label: 'E-mailadresse',
      placeholder: 'Indtast e-mailadresse',
    },
  },
  channel_chooser: {
    title: 'Send kode via',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Gratis, hurtigste levering',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Almindelig tekstbesked',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'E-mail',
      subtitle: 'Koden direkte i din indbakke',
    },
  },
  otp: {
    title: 'Indtast bekræftelseskode',
    send_code: 'Send kode',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Sendt via <strong>WhatsApp</strong> til <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Sendt via <strong>SMS</strong> til <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Sendt via <strong>e-mail</strong> til <strong>{{phone}}</strong>',
    },
    sent_to: 'Sendt til',
    resend: {
      title: 'Har du ikke modtaget koden?',
      countdown: 'Send igen om',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: 'Har du ikke modtaget koden via e-mail?',
          button: 'Send igen via e-mail',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: 'Har du ikke modtaget koden?',
          button: 'Send igen via SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: 'Har du ikke modtaget koden?',
          button: 'Send igen via WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Send via SMS i stedet',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Send via WhatsApp i stedet',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'En besked med en bekræftelseskode er sendt til din telefon. Indtast koden for at fortsætte.',
      [OTP_DELIVERY_CHANNELS.EMAIL]:
        'Indtast koden, der er sendt til denne adresse: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'En WhatsApp-besked med en bekræftelseskode er sendt til din telefon. Indtast koden for at fortsætte.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Tip: Tjek din indbakke og din spam-mappe.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Bemærk: Koden sendes fra <strong>{{sender}}</strong>, vores teknologipartner.',
    business_account: 'Erhvervskonto',
    message: '<strong>123456</strong> er din bekræftelseskode. Af hensyn til din sikkerhed må du ikke dele denne kode.',
  },
  error_messages: {
    frequent_requests:
      'Tjek dine beskeder. Vi har allerede sendt koden til det angivne nummer. Hvis ikke, så tjek telefonnummeret, eller prøv igen om 10 minutter.',
    frequent_requests_email:
      'Tjek din indbakke og din spam-mappe. Vi har allerede sendt koden til den adresse. Hvis den ikke er kommet frem, så prøv igen om 10 minutter.',
    invalid_number: 'Ugyldigt nummer. Prøv igen.',
    invalid_email: 'Vi kunne ikke sende koden til den e-mailadresse. Tjek den, og prøv igen.',
    email_not_on_file:
      'Dette telefonnummer har allerede en konto uden e-mailadresse. Kontakt {{support_email}} for at tilføje en – indtil da kan vi ikke sende koder til dette nummer via e-mail.',
    turnstile_required: 'Gennemfør bekræftelsen, før du anmoder om en ny kode.',
    generic_error: 'Ups, noget gik galt. Opdater siden, og prøv igen.',
    change_phone_number_unsuccessful: 'Telefonnummeret kunne ikke ændres. Prøv igen.',
  },
  toasts: {
    code_sent: 'Kode sendt',
  },
};
